import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import {
    ACCOUNTS_ROUTE,
    BANK_ACCOUNTS_ROUTE,
    DASHBOARD_ROUTE,
    FORGOT_PASSWORD_ROUTE,
    LOGIN_ROUTE,
    PAYMENT_CONFIRMATION_ROUTE,
    RESET_PASSWORD_ROUTE,
    SIGNUP_ROUTE,
    SET_PASSWORD_ROUTE,
    SUBSCRIPTION_ROUTE,
    SUBSCRIPTION_VERIFY_ROUTE,
    VERIFICATIONS_ROUTE,
} from "@/router/routes";
import { ifNotAuthDeny } from "@/router/guards/not_auth";
import { ifAuthDeny } from "@/router/guards/auth";
import DashboardView from "@/views/Dashboard.vue";
import LoginView from "@/views/auth/Login.vue";
import SignupView from "@/views/auth/Signup.vue";
import ForgotPasswordView from "@/views/auth/Forgot_Password.vue";
import SetPasswordView from "@/views/auth/Set_Password.vue";
import VerificationsView from "@/views/Verifications.vue";
import AccountsView from "@/views/Accounts.vue";
import BankAccountsView from "@/views/Bank_Accounts.vue";
import SubscriptionView from "@/views/Subscription.vue";
import PaymentConfirmationView from "@/views/Payment_Confirmation.vue";
import { redirectOn404 } from "./404_handler";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        name: DASHBOARD_ROUTE,
        beforeEnter: ifNotAuthDeny,
        component: DashboardView,
    },
    {
        path: "/login",
        name: LOGIN_ROUTE,
        beforeEnter: ifAuthDeny,
        component: LoginView,
    },
    {
        path: "/signup",
        name: SIGNUP_ROUTE,
        beforeEnter: ifAuthDeny,
        component: SignupView,
    },
    {
        path: "/forgot-password",
        name: FORGOT_PASSWORD_ROUTE,
        beforeEnter: ifAuthDeny,
        component: ForgotPasswordView,
    },
    {
        // Reset password from the "forgot password" email link.
        path: "/reset-password/:token",
        name: RESET_PASSWORD_ROUTE,
        beforeEnter: ifAuthDeny,
        component: SetPasswordView,
    },
    {
        // Staff invite: set initial password and verify email.
        path: "/set-password/:token",
        name: SET_PASSWORD_ROUTE,
        beforeEnter: ifAuthDeny,
        component: SetPasswordView,
    },
    {
        path: "/verifications",
        name: VERIFICATIONS_ROUTE,
        beforeEnter: ifNotAuthDeny,
        component: VerificationsView,
    },
    {
        path: "/accounts",
        name: ACCOUNTS_ROUTE,
        beforeEnter: ifNotAuthDeny,
        component: AccountsView,
    },
    {
        path: "/bank-accounts",
        name: BANK_ACCOUNTS_ROUTE,
        beforeEnter: ifNotAuthDeny,
        component: BankAccountsView,
    },
    {
        path: "/subscription",
        name: SUBSCRIPTION_ROUTE,
        beforeEnter: ifNotAuthDeny,
        component: SubscriptionView,
    },
    {
        // Public page Chapa returns to after checkout
        // (/payment/confirmation?tx_ref=… — also accepts ?paymentId= / ?subscription=).
        // Intentionally NOT auth-guarded: the browser returning from Chapa's hosted
        // checkout (or a mobile in-app browser) may have no active web session, and
        // the payment must still be confirmable. Verification uses a public endpoint.
        path: "/payment/confirmation",
        name: PAYMENT_CONFIRMATION_ROUTE,
        component: PaymentConfirmationView,
    },
    {
        // Backwards-compatible alias for the previous Chapa return url so any
        // payment already in flight against the old return_url still lands correctly.
        path: "/subscription/verify",
        name: SUBSCRIPTION_VERIFY_ROUTE,
        component: PaymentConfirmationView,
    },
    {
        path: '/:pathMatch(.*)*',
        beforeEnter: redirectOn404,
        component: DashboardView,
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
